import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Typography,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import PaginacionControl from '../components/PaginacionControl';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import FileDownloadIcon from '@mui/icons-material/GetApp';
import AddIcon from '@mui/icons-material/Add';
import { GridOn } from '@mui/icons-material';

const Colores = () => {
  // Exportar Excel
  const exportExcel = async () => {
    const { exportGenericWorkbook } = await import('../utils/excel/genericWorkbook');
    const rows = colores
      .filter(color => color.nombre.toLowerCase().includes(searchValue.toLowerCase()))
      .map(color => ({ id: color.id, nombre: color.nombre }));
    await exportGenericWorkbook({
      titulo: 'REPORTE DE COLORES',
      sheetName: 'Colores',
      tableName: 'tblColores',
      fileName: 'Colores',
      columns: [
        { key: 'id', label: 'ID', width: 8 },
        { key: 'nombre', label: 'Nombre', width: 26 }
      ],
      rows,
      searchText: searchValue,
      usuario: ''
    });
  };
  const [searchValue, setSearchValue] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [colores, setColores] = useState([]);
  const [open, setOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const [nombre, setNombre] = useState('');

  const fetchColores = async () => {
    const res = await axios.get('/api/colores');
    setColores(res.data);
  };

  useEffect(() => {
    fetchColores();
  }, []);

  const handleOpen = (color = null) => {
    if (color) {
      setEditId(color.id);
      setNombre(color.nombre);
    } else {
      setEditId(null);
      setNombre('');
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditId(null);
    setNombre('');
  };

  const handleSave = async () => {
    if (!nombre) return;
    try {
      if (editId) {
        await axios.put(`/api/colores/${editId}`, { nombre });
      } else {
        await axios.post('/api/colores', { nombre });
      }
      fetchColores();
      handleClose();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al guardar');
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/api/colores/${id}`);
      fetchColores();
    } catch { alert('Error al eliminar'); }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 1, mb: 4, width: '100%' }}>
      <Box sx={{ width: { xs: '100%', sm: '95%', md: '90%' }, maxWidth: 1800, mt: { xs: '0em', sm: '0em', md: '0em' } }}>
        <Typography variant="h4" gutterBottom sx={{ textAlign: { xs: 'center', md: 'left' }, mb: 3, fontWeight: 'bold', color: '#222' }}>Colores</Typography>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
          <TextField
            placeholder="Buscar..."
            value={searchValue}
            onChange={e => { setSearchValue(e.target.value); setPage(0); }}
            size="small"
            sx={{ flex: 1 }}
          />
          <Button color="success" variant="contained" sx={{ minWidth: 120 }} onClick={exportExcel} startIcon={<GridOn />}>
            Exportar Excel
          </Button>
          <Button variant="contained" startIcon={<AddIcon />} onClick={() => handleOpen()} sx={{ ml: { xs: 0, sm: 'auto' }, mt: { xs: 2, sm: 0 } }}>Nuevo Color</Button>
          <TextField
            size="small"
            label="Mostrar"
            type="number"
            value={rowsPerPage}
            onChange={e => { setRowsPerPage(Number(e.target.value)); setPage(0); }}
            sx={{ width: 100 }}
          />
        </Box>
        <TableContainer component={Paper} sx={{ borderRadius: 4, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', mt: 2, overflowX: 'auto' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center" sx={{ pr: 8 }}>ID</TableCell>
                <TableCell align="center">Nombre</TableCell>
                <TableCell align="center">Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {colores
                .filter(color => {
                  const search = searchValue.toLowerCase();
                  return (
                    color.nombre.toLowerCase().includes(search) ||
                    color.id.toString().includes(search)
                  );
                })
                .slice(rowsPerPage === -1 ? 0 : page * rowsPerPage, rowsPerPage === -1 ? undefined : (page + 1) * rowsPerPage)
                .map((color) => (
                  <TableRow key={color.id}>
                    <TableCell align="center" sx={{ pr: 8 }}>{color.id}</TableCell>
                    <TableCell align="center">{color.nombre}</TableCell>
                    <TableCell align="center">
                      <IconButton color="primary" onClick={() => handleOpen(color)}><EditIcon /></IconButton>
                      <IconButton color="error" onClick={() => handleDelete(color.id)}><DeleteIcon /></IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <PaginacionControl
          page={page}
          rowsPerPage={rowsPerPage}
          count={colores.filter(color => color.nombre.toLowerCase().includes(searchValue.toLowerCase())).length}
          onPageChange={setPage}
        />
        <Dialog open={open} onClose={(_, r) => r !== 'backdropClick' && handleClose()} disableEscapeKeyDown={false} maxWidth="sm" fullWidth>
          <DialogTitle>
            <Typography variant="h5" fontWeight="bold">
              {editId ? 'Editar Color' : 'Nuevo Color'}
            </Typography>
          </DialogTitle>
          <DialogContent>
            <TextField
              label="Nombre"
              value={nombre}
              onChange={e => setNombre(e.target.value)}
              fullWidth
              margin="dense"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} startIcon={<CloseIcon />} color="error" variant="contained">Cancelar</Button>
            <Button onClick={handleSave} variant="contained" startIcon={<SaveIcon />} color="primary">Guardar</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
};

export default Colores;
